export default __webpack_public_path__ + "src/assets/icn-cant-freeze.a2ccf171f6fc316a179f8ccd35a68b30.svg";